/* global axios */
import ApiClient from './ApiClient';

class MonitoringAPI extends ApiClient {
  constructor() {
    super('monitoring', { accountScoped: true, apiVersion: 'v2' });
  }

  // GK-HUB: Team-based scoping (supervisor auto-scoped on backend via team_ids)
  get({ inboxId, teamId } = {}) {
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
      },
    });
  }
}

export default new MonitoringAPI();
